import { useState, useContext } from 'react';
import { db } from '../firebase/firebase';
import { collection, getDocs, doc, deleteDoc, addDoc, Timestamp } from "firebase/firestore";
import { AuthContext } from '../context/AuthContext';
import { pricingPlansSeedData } from '../data/pricingPlansSeedData';

export const useDataSetup = () => {
  const { user: adminUser } = useContext(AuthContext);
  const [setupLoading, setSetupLoading] = useState(false);
  const [setupStatus, setSetupStatus] = useState({});

  const seedPricingPlans = async () => {
    setSetupLoading(true);
    setSetupStatus(prev => ({ ...prev, pricingPlans: 'loading' }));
    
    try {
      // Clear existing plans first
      const existingPlansRef = collection(db, "pricingPlans");
      const existingPlansSnapshot = await getDocs(existingPlansRef);
      
      for (const planDoc of existingPlansSnapshot.docs) {
        await deleteDoc(doc(db, "pricingPlans", planDoc.id));
      }
      
      // Add new plans
      for (const plan of pricingPlansSeedData) {
        await addDoc(collection(db, "pricingPlans"), {
          ...plan,
          createdAt: Timestamp.now(),
          updatedAt: Timestamp.now(),
          createdBy: adminUser?.uid || 'admin',
          lastModifiedBy: adminUser?.uid || 'admin'
        });
      }
      
      setSetupStatus(prev => ({ ...prev, pricingPlans: 'success' }));
      return { success: true };
    } catch (err) {
      console.error("Error seeding pricing plans: ", err);
      setSetupStatus(prev => ({ 
        ...prev, 
        pricingPlans: 'error',
        message: err.message 
      }));
      return { success: false, error: err.message };
    } finally {
      setSetupLoading(false);
    }
  };

  const resetSetupStatus = () => {
    setSetupStatus({});
  };

  return {
    setupLoading,
    setupStatus,
    seedPricingPlans,
    resetSetupStatus
  };
}; 